module.exports = __webpack_public_path__ + "img/logo_icon.233ab18f.png";